import React from 'react';
import ReactDOM from "react-dom";
import Loader from "./components/Loader";
import Summary from "./components/Summary";
import AccordionFrame from "./components/AccordionFrame";
import Information from "./components/Information";
import SummaryError from "./components/SummaryError";
import Message from "./components/Message";
import LogoutInfo from "./components/LogoutInfo";
import Timeout from "./components/Timeout";


export function formatNumber(value) {
    //return numberWithSpaces( (value / 100).toFixed(2).replace(",", ",") );
    return numberWithSpaces( (value / 100).toFixed(2) );
}

export function formatSsn(value) {
    return value.substring(0, 6) + " " + value.substring(6);

}

function numberWithSpaces(x) {
    var parts = x.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(",");
}



export function coborrower(value) {
    if (value === "0") {
        return "Ingen";
    }
    else if (value === "1") {
        return "Er";
    }
    else if (value === "2") {
        return "Finnes";
    }
    else {
        return "";
    }
}


export function getPeriod(value) {
    if (value === "MONTHLY") {
        return "Månedlig";
    }
    else if (value === "QUARTERLY") {
        return "Kvartalsvis";
    }
    else if (value === "HALF_YEARLY") {
        return "Halvårlig";
    }
    else if (value === "YEARLY") {
        return "Årlig";
    }
    else {
        return value;
    }
}



export function tableStripes(value, last) {
    if (value % 2 === 0) {
        if (last)
            return "whiteStripeLast";
        else
            return "whiteStripe";
    }
    else {
        if (last)
            return "greyStripeLast";
        else
            return "greyStripe";
    }
}


const updateHours = 26;


export function isShowingUpdatetMarking(date) {
    var strDate = date.replace(/\./g, ":").replace(/ /g, ":").split(":");
    var newDate = new Date(strDate[2], strDate[1] - 1, strDate[0], strDate[3], strDate[4]);
    var currentDate = new Date();
    var seconds = Math.abs(currentDate - newDate) / 1000;
    var hours = Math.floor(seconds / 3600);
    if (hours > updateHours) {
        return true;
    }
    else {
        return false;
    }
}



export function checkUpdatetMarking(props) {
    const date = props.datetime;
    var strDate = date.replace(/\./g, ":").replace(/ /g, ":").split(":");
    var newDate = new Date(strDate[2], strDate[1] - 1, strDate[0], strDate[3], strDate[4]);
    var currentDate = new Date();
    var seconds = Math.abs(currentDate - newDate) / 1000;
    var hours = Math.floor(seconds / 3600);
    if (hours > updateHours) {
        return (
            <span class="updatetMarkingInfo">!&nbsp;</span>
        )
    }
    return (null);
}


export function showUpdatetMarkingInfo(props) {
    const showInfo = props.showInfo;
    const indexLoanLast = props.indexLoanLast;
    const colspan = props.colspan;
    if (showInfo) {
        return (
            <tr style={{borderBottomWidth:'0px'}} className={tableStripes(indexLoanLast, true)}>
                <td className="cellLeft" colSpan={colspan}><span className="updatetMarkingInfo">!&nbsp;</span>Informasjonen har ikke blitt oppdatert hos Gjeldsregisteret siste {updateHours} timer</td>
            </tr>
        );
    }
    return (null);
}


export function wrapDateTime(props) {
    const datetime = props.datetime;
    var splitDatetime = datetime.split(" ");
    return (
        <span>{splitDatetime[0]}<br/>{splitDatetime[1]}</span>
    );
}


export function getConsentText(active_consent, to_date) {
    console.log("active_consent: " + active_consent);
    console.log("to_date: " + to_date);
    console.log("--------------------------------------------");

    //	"18.02.2021"
    var splitDate = to_date.split(".");
    var newToDate = new Date(splitDate[2], splitDate[1], splitDate[0]);
    var currentDate = new Date();

    console.log("newToDate: " + newToDate);
    console.log("currentDate: " + currentDate);
    console.log("--------------------------------------------");


    if (active_consent === true && newToDate < currentDate)  {
        console.log("Utgått: " + active_consent);
        return ( "Utgått" )
    }
    else {
        console.log("Opphevet: " + active_consent);
        return ( "Opphevet" )
    }
}




export function getDataFromLocalBackend() {
    const urlList = window.location.href + "/api/v2/loans/list";

    fetch(urlList, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin'
    })
        .then(function (response) {
            if (response.status === 403) {
                throw new Error(response.status);
            }
            return response.json();
        })
        .then(function (data) {
            ReactDOM.render(<Loader show={false}/>, document.getElementById('Loader'));

            if (data.errorCode === undefined && data.status !== 401 && data.status !== 503) {
                ReactDOM.render(<Summary summary={data.summary}/>, document.getElementById('summary'));
                ReactDOM.render(<AccordionFrame list={data.list} summary={data.summary}/>, document.getElementById('accordionframe'));
                ReactDOM.render(<Information/>, document.getElementById('information'));
            }
            else {
                var message;
                var type;
                if (data.errorCode === '4100' || data.errorCode === '3000' || data.errorCode === '3001') {
                    message = "Ingen usikret gjeld er registrert";
                    type = "infoMessage";
                    ReactDOM.render(<SummaryError data={data}/>, document.getElementById('summaryerror'));
                    ReactDOM.render(<Message error={message} type={type}/>, document.getElementById('message'));
                    ReactDOM.render(<AccordionFrame list={data.list} summary={data.summary}/>, document.getElementById('accordionframe'));
                    ReactDOM.render(<Information/>, document.getElementById('information'));
                }
                else {
                    message = "Tjenesten er ikke tilgjengelig for øyeblikket, prøv igjen senere";
                    type = "errorMessage";
                    ReactDOM.render(<SummaryError data={data}/>, document.getElementById('summaryerror'));
                    ReactDOM.render(<Message error={message} type={type}/>, document.getElementById('message'));
                    ReactDOM.render(<Information/>, document.getElementById('information'));
                }
            }
        })
        .catch(function (error) {
            if (error.message === '403') {
                ReactDOM.render(<Loader show={false}/>, document.getElementById('Loader'));
                ReactDOM.render(<LogoutInfo show={false}/>, document.getElementById('logoutinfo'));
                ReactDOM.render(<Timeout type={'warningMessage'}/>, document.getElementById('timeout'));
                ReactDOM.render(<Information/>, document.getElementById('information'));

                //         setTimeout(function() {
                //             loginIDporten();
                //         },50000);
            }
            else {
                ReactDOM.render(<Loader show={false}/>, document.getElementById('Loader'));
                ReactDOM.render(<Message error='Tjenesten er ikke tilgjengelig for øyeblikket, prøv igjen senere' type={'errorMessage'}/>, document.getElementById('message'));
                ReactDOM.render(<Information/>, document.getElementById('information'));
            }
        })
}